import { createContext } from "react";

export const AriaLabelForContext = createContext("");
